import axios from '@/axios'
import * as types from '../../mutation-types'

export default {
    namespaced: true,

    state: {
        slices: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/salaries/slices').then(({ data }) => {
                commit(types.STORE_SLICES, data);
                return data;
            })
        },

        create({ commit }, { name }) {
            return axios.post('/salaries/salarySlice', { name });
        },

        update({ commit }, { id, name }) {
            return axios.put(`/salaries/salarySlice/${id}`, { name });
        },
    },

    mutations: {
        [types.STORE_SLICES](state, slices) {
            state.slices = slices;
        }
    },

    getters: {
        getSliceById: state => id => state.slices.find(c => c.id === id)
    }
}